import { element } from 'protractor';
import { Component, Inject, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { TranslateService } from '@ngx-translate/core';
import { GuiService } from 'src/app/services/gui.service';
import { RestService } from 'src/app/services/rest.service';
import { environment } from 'src/environments/environment';
import { NutritionComponent } from '../../nutrition.component';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CloseConfirmComponent } from 'src/app/admin/close-confirm/close-confirm.component';
import { FullViewDietComponent } from './full-view-diet/full-view-diet.component';
import dishComposeMap from '../../../../../assets/dish-compose.json';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'vex-compose-diet',
  templateUrl: './compose-diet.component.html',
  styleUrls: ['./compose-diet.component.scss',
    '../../../../../../node_modules/quill/dist/quill.snow.css',
    '../../../../../@vex/styles/partials/plugins/quill/_quill.scss'
  ],
  encapsulation: ViewEncapsulation.None
})
export class ComposeDietComponent implements OnInit, OnDestroy {
  nutrition = {
    bmi: "",
    dailyKcal: "",
    energyRequirement: "",
    carbohydrates: "",
    fats: "",
    protein: "",
    physicalActivityLevel: "",
    mb: "",
    note: ""
  };

  recipes = [];
  searchCtrl = new UntypedFormControl();
  filter = {
    selectedCategory: "",
    selectedTags: ""
  };
  categories = [
    { key: 'colazione', description: 'Colazione' },
    { key: 'pranzo', description: 'Pranzo' },
    { key: 'cena', description: 'Cena' },
    { key: 'merenda', description: 'Merenda' }
  ];
  availableTags: string[] = ['Senza glutine', 'Senza lattosio', 'Vegetariana', 'Vegana', 'Salato', 'Dolce'];
  pageSize = 4;
  pageNumber = 1;
  lunghezza: any;
  environmentNode = environment.baseURL.node;
  selectedRecipe;
  recipeToSend = {
    colazione: [],
    pranzo: [],
    cena: [],
    spuntini: []
  };
  currentStep = 0;
  recipeKeys = Object.keys(this.recipeToSend);
  mealCategories = [];
  expandedCardId: string | null = null;
  ingredients = {};
  dietStatus;
  userInfoAccordion: boolean = false;
  expandedIngredientId = null;
  editingRecipeInfo: boolean = false;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  selectedPrecompiledCalories;
  precompiledOptions = [
    { key: 'base', description: '' },
    { key: '1700', description: '1700' },
    { key: '1800', description: '1800' },
    { key: '1900', description: '1900' },
    { key: '2000', description: '2000' }
  ];
  private autosaveTimeoutId: any;
  private autosaveIntervalId: any;
  isAutosaving = false;
  imageControllers = new Map<string, AbortController>();

  constructor(@Inject(MAT_DIALOG_DATA) public item: any['item'],private sanitizer: DomSanitizer, public guiService: GuiService, public translate: TranslateService, private restService: RestService, private dialogRef: MatDialogRef<NutritionComponent>, private dialog: MatDialog) { }

  ngOnInit(): void {
    if (this.guiService.userLogged) {
      this.getMealCategories();
    } else {
      this.getCurrent();
    }
  }

  startAutosave(): void {
    if (this.dietStatus !== 'send') {
      this.autosaveTimeoutId = setTimeout(() => {
        this.sendForAutoSave();
        this.autosaveIntervalId = setInterval(() => {
          this.sendForAutoSave();
        }, 3 * 60 * 1000); // ogni 3 minuti
      }, 3 * 60 * 1000); // dopo 3 minuti
    }
  }

  stopAutosave(): void {
    clearTimeout(this.autosaveTimeoutId);
    clearInterval(this.autosaveIntervalId);
  }

  ngOnDestroy(): void {
    this.stopAutosave();
  }

  getCurrent() {
    setTimeout(() => this.guiService.showSpinner = true, 0)
    this.restService.getService('current_user', '').subscribe((ris) => {
      this.guiService.userLogged = ris;
      this.getMealCategories();
    })
  }

  populateDiet() {
    setTimeout(() => this.guiService.showSpinner = true, 0)
    this.restService.postService('node', '/get-diet', { userId: this.guiService.userLogged.user.id, dietId: this.item.survey.diet.documentFileName }).subscribe((ris) => {
      console.debug('diet response', ris);
      this.dietStatus = ris.status;
      this.nutrition = ris.infos;
      this.recipeToSend = ris.recipes;
      this.mealCategories = ris.dishComposeInfos;
      this.guiService.showSpinner = false;
      this.search()
      this.startAutosave();
    })
  }

  onPageChanged(pageEvent: PageEvent) {
    this.pageNumber = pageEvent.pageIndex + 1;
    this.pageSize = pageEvent.pageSize;
    this.search();
  }

 search(resetPage?: boolean) {
  setTimeout(() => this.guiService.showSpinner = true, 0);

  if (resetPage) {
    this.pageNumber = 1;
    this.paginator.pageIndex = 0;
  }

  // Interrompe tutte le immagini in caricamento
  this.imageControllers.forEach(ctrl => ctrl.abort());
  this.imageControllers.clear();

  const param: any = {
    page: this.pageNumber,
    size: this.pageSize,
    userId: this.guiService.userLogged.user.id
  };

  this.selectedRecipe = null;

  if (this.searchCtrl.value && this.searchCtrl.value !== '') {
    param['langKey'] = this.translate.currentLang.toUpperCase();
    param['i18nTitleFilter'] = this.searchCtrl.value;
  }
  if (this.filter.selectedTags && this.filter.selectedTags !== '') {
    param['tagFilter'] = this.filter.selectedTags;
  }
  if (this.filter.selectedCategory && this.filter.selectedCategory !== '') {
    param['categoryFilter'] = this.filter.selectedCategory;
  }

  // Timeout di sicurezza per la richiesta di lista
  const timeoutPromise = (ms: number, promise: Promise<any>) =>
    new Promise((resolve, reject) => {
      const timer = setTimeout(() => reject(new Error('Request Timeout')), ms);
      promise
        .then(res => { clearTimeout(timer); resolve(res); })
        .catch(err => { clearTimeout(timer); reject(err); });
    });

  timeoutPromise(15000, this.restService.postService('node', '/recipes-list', param).toPromise())
    .then((ris: any) => {
      // Aggiungiamo campo imageUrl vuoto per le immagini
      this.recipes = ris.items.map(r => ({ ...r, imageUrl: '' }));

      // Carica solo le immagini delle ricette attuali
      this.recipes.forEach(r => this.loadRecipeImage(r));

      this.lunghezza = ris.totalItems;
      this.guiService.showSpinner = false;
    })
    .catch(err => {
      console.error('⚠️ Errore nella richiesta recipes-list:', err);
      this.recipes = [];
      this.lunghezza = 0;
      this.guiService.showSpinner = false;
    });
}

  getMealCategories() {
    this.mealCategories = dishComposeMap.base;
    this.filter.selectedCategory =  this.categories[this.currentStep].key;
    this.getIngredients();
  }

  addSelectedRecipeTo(to: string) {
    if (this.selectedRecipe && this.recipeToSend[to].length < 7) {
      this.recipeToSend[to].push(JSON.parse(JSON.stringify(this.selectedRecipe)));
      const lastIndex = this.recipeToSend[to].length - 1;
      this.setFullIngredients(this.recipeToSend[to][lastIndex]);
      this.guiService.openSnackBar(this.translate.instant('GLOBAL.ADDED_SUCCESS'), "OK!")
      this.selectedRecipe = null;
      this.updateStorageDietSummary();
    }
  }

  confirmClose() {
    this.dialog.open(CloseConfirmComponent, {
      disableClose: true,
      hasBackdrop: true,
      panelClass: 'close-dialog-modalbox'
    }).afterClosed().subscribe((ris) => {
      if (ris == 'true') {
        this.dialogRef.close()
      }
    })
  }

  nextStep() {
    this.currentStep++;
    this.expandedCardId = null;
    this.setCategory();
  }

  prevStep() {
    if (this.currentStep > 0) {
      this.currentStep--;
      this.expandedCardId = null;
      this.setCategory();
    }
  }

  setCategory(){
    if(this.currentStep < 4){
      this.searchCtrl.reset();
      this.filter.selectedTags = '';
      this.filter.selectedCategory =  this.categories[this.currentStep].key;
      this.search(true);
    }
  }

  deleteRecipe(recipe) {
    const stepKey = this.recipeKeys[this.currentStep];
    const recipeIndex = this.recipeToSend[stepKey].indexOf(recipe);
    if (recipeIndex !== -1) {
      this.recipeToSend[stepKey].splice(recipeIndex, 1);
      this.updateStorageDietSummary();
    }
  }

  areAllFoodsFilled(): boolean {
    return this.mealCategories.every(obj =>
      obj.foods.every(food =>
        food.value && food.value.trim() !== ''
      )
    );
  }

  areAllNutritionalValuesFilled(): boolean {
  return Object.entries(this.nutrition)
    .filter(([key, _]) => key !== 'note')
    .every(([_, value]) => value !== null && value !== '');
  }


  areAllMealsComplete(): boolean {
    const allowedUnits = ['a.n.', 'q.b.', 'as needed', 'quanto basta'];

    return Object.values(this.recipeToSend).every(arr =>
      Array.isArray(arr) &&
      arr.length >= 1 &&
      arr.every(item =>
        item.ingredientsFull &&
        Object.values(item.ingredientsFull).every((ingredient: any) =>
          allowedUnits.includes(ingredient.unit?.en) ||
          allowedUnits.includes(ingredient.unit?.it) ||
          (ingredient.quantity !== "" && ingredient.quantity !== null)
        )
      )
    );
  }

  areSingleMealCompleted(obj: Object): boolean {
    const allowedUnits = ['a.n.', 'q.b.', 'as needed', 'quanto basta'];

    return Object.values(obj).every((item: any) =>
      allowedUnits.includes(item.unit?.en) ||
      allowedUnits.includes(item.unit?.it) ||
      (item.quantity !== "" && item.quantity !== null)
    );
  }

  send() {
    const objToSend = {
      infos: this.nutrition,
      recipes: this.recipeToSend,
      dishComposeInfos: this.mealCategories,
      userId: this.guiService.userLogged.user.id,
      surveyId: this.item.survey.id,
      extUserEmail: this.item.userEmail,
      extUserId: this.item.survey.userId,
      nutriEmail: this.guiService.userLogged.user.email
    };

    this.item.survey.diet ? objToSend['tmpDiet'] = this.item.survey.diet.documentFileName : null;

    this.stopAutosave();

    if (this.areAllMealsComplete() && this.areAllFoodsFilled() && this.areAllNutritionalValuesFilled()) {
      console.debug('TUTTI I CAMPI SONO STATI RIEMPITI');

      objToSend['status'] = 'send';
      setTimeout(() => this.guiService.showSpinner = true, 0)
      this.restService.postService('node', '/set-diet', objToSend).subscribe((ris) => {
        console.debug(ris);
        this.guiService.showSpinner = false;
        this.guiService.openSnackBar(this.translate.instant('GLOBAL.DIET_LOAD'), this.translate.instant('GLOBAL.CLOSE'));
        this.dialogRef.close('done');
      })

    } else {
      console.debug('NON SONO STATI COMPILATI TUTTI I CAMPI');

      objToSend['status'] = 'draft';
      setTimeout(() => this.guiService.showSpinner = true, 0)
      this.restService.postService('node', '/set-diet', objToSend).subscribe((ris) => {
        console.debug(ris);
        this.guiService.showSpinner = false;
        !this.item.survey.diet ? this.dialogRef.close('done') : null;
        this.guiService.openSnackBar(this.translate.instant('GLOBAL.SAVED'), this.translate.instant('GLOBAL.CLOSE'));
      })
    }

  }

  onEdit(item: any, index): void {
    console.debug('item', item)
    this.expandedCardId = item._id + '_' + index;
  }

  setFullIngredients(item) {
    console.debug(item)
    item.ingredientsFull = {};
    item.ingredients.forEach(element => {
      item.ingredientsFull[element] = JSON.parse(JSON.stringify(this.ingredients[element]));
    });
  }

  getIngredients() {
    setTimeout(() => this.guiService.showSpinner = true, 0);
    this.restService.postService('node', '/ingredients-list', { userId: this.guiService.userLogged.user.id }).subscribe((ris) => {
      ris.forEach(element => {
        this.ingredients[element._id] = element;
        this.ingredients[element._id].quantity = '';
      });
      this.guiService.showSpinner = false;
      if(this.item.survey.diet){
        this.populateDiet()
      }else{
        this.search()
        this.startAutosave();
      }
    })
  }

  getEmptySpace(objLength) {
    const emptyCount = 7 - objLength;
    return Array(emptyCount)
  }

  duplicateRecipe(recipe) {
    const stepKey = this.recipeKeys[this.currentStep];
    if (this.recipeToSend[stepKey].length < 7) {
      this.recipeToSend[stepKey].push((JSON.parse(JSON.stringify(recipe))));
      this.updateStorageDietSummary();
    }
  }

  moveRight(index) {
    if (index < 7) {
      const stepKey = this.recipeKeys[this.currentStep];
      const tmpItem = this.recipeToSend[stepKey][index];
      this.recipeToSend[stepKey][index] = this.recipeToSend[stepKey][index + 1];
      this.recipeToSend[stepKey][index + 1] = tmpItem;
      this.updateStorageDietSummary();
    }
  }

  moveLeft(index) {
    if (index > 0) {
      const stepKey = this.recipeKeys[this.currentStep];
      const tmpItem = this.recipeToSend[stepKey][index];
      this.recipeToSend[stepKey][index] = this.recipeToSend[stepKey][index - 1];
      this.recipeToSend[stepKey][index - 1] = tmpItem;
      this.updateStorageDietSummary();
    }
  }

  editRecipeIngredient(id) {
    this.expandedIngredientId = id;
  }

  saveRecipeIngredient() {
    this.expandedIngredientId = null;
  }

  editRecipeInfo() {
    this.editingRecipeInfo = true;
  }

  saveRecipeInfo() {
    this.editingRecipeInfo = false;
  }

  reduceExpand(){
    this.editingRecipeInfo = false;
    this.expandedCardId = null;
  }

  openSummary() {
    localStorage.setItem('dietRecipe', JSON.stringify(this.recipeToSend));
    window.open('/#/auth/diet-summary');
  }

  updateStorageDietSummary(){
    localStorage.setItem('dietRecipe', JSON.stringify(this.recipeToSend));
  }

  onCaloriesChange(){
    this.mealCategories = dishComposeMap[this.selectedPrecompiledCalories];
  }

  sendForAutoSave() {
    const objToSend = {
      infos: this.nutrition,
      recipes: this.recipeToSend,
      dishComposeInfos: this.mealCategories,
      userId: this.guiService.userLogged.user.id,
      surveyId: this.item.survey.id,
      extUserEmail: this.item.userEmail,
      extUserId: this.item.survey.userId,
      nutriEmail: this.guiService.userLogged.user.email
    };

    this.item.survey.diet ? objToSend['tmpDiet'] = this.item.survey.diet.documentFileName : null;

    objToSend['status'] = 'draft';

    this.guiService.openSnackBar(this.translate.instant('GLOBAL.AUTOSAVE'));
    this.isAutosaving = true;

    this.restService.postService('node', '/set-diet', objToSend).subscribe((ris) => {
      if(!this.item.survey.diet){
        this.restService.getService('users', this.item.survey.userId + '/nutrition-surveys').subscribe((ris) => {
          const surveys = ris;
          const diet = surveys.find(x => x.id === this.item.survey.id).diet;
          console.debug('DIET FOUND ON AUTOSAVE TO PREVENT MULTIPLE SAVE RECORD', diet);
          this.item.survey.diet = diet;
          this.guiService.openSnackBar(this.translate.instant('GLOBAL.SAVED'));
          this.isAutosaving = false;
        })
      }else{
        console.debug(ris);
        this.guiService.openSnackBar(this.translate.instant('GLOBAL.SAVED'));
        this.isAutosaving = false;
      }
    })

  }

  edit() {
    const objToSend = {
      infos: this.nutrition,
      recipes: this.recipeToSend,
      dishComposeInfos: this.mealCategories,
      userId: this.guiService.userLogged.user.id,
      surveyId: this.item.survey.id,
      extUserEmail: this.item.userEmail,
      extUserId: this.item.survey.userId,
      nutriEmail: this.guiService.userLogged.user.email
    };

    this.item.survey.diet ? objToSend['tmpDiet'] = this.item.survey.diet.documentFileName : null;

    this.stopAutosave();

    if (this.areAllMealsComplete() && this.areAllFoodsFilled() && this.areAllNutritionalValuesFilled()) {
      console.debug('TUTTI I CAMPI SONO STATI RIEMPITI');

      objToSend['status'] = 'send';
      setTimeout(() => this.guiService.showSpinner = true, 0)
      this.restService.postService('node', '/edit-diet', objToSend).subscribe((ris) => {
        console.debug(ris);
        this.guiService.showSpinner = false;
        this.guiService.openSnackBar(this.translate.instant('GLOBAL.DIET_EDIT_LOAD'), this.translate.instant('GLOBAL.CLOSE'));
        this.dialogRef.close('done');
      })

    }
  }

  loadRecipeImage(recipe: any) {
  // Se esiste già un controller per questa ricetta, abortiamo
  if (this.imageControllers.has(recipe._id)) {
    this.imageControllers.get(recipe._id)?.abort();
  }

  const controller = new AbortController();
  this.imageControllers.set(recipe._id, controller);

  fetch(`${this.environmentNode}/get-recipe-image/${recipe._id}`, { signal: controller.signal })
    .then(res => res.blob())
    .then(blob => {
      recipe.imageUrl = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(blob));
      // Una volta caricata l'immagine rimuoviamo il controller
      this.imageControllers.delete(recipe._id);
    })
    .catch(err => {
      if (err.name === 'AbortError') {
        console.log(`Download immagine ${recipe._id} interrotto`);
      } else {
        console.error(err);
      }
    });
}

}
